import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from "react-router";
import clsx from "clsx";

import AppBar from '@material-ui/core/AppBar';

import useStyles from './styles';
import {UserUtils} from "../../utils/utils";
import ReportGenerationHandler from "../ReportsGenerationHandler/ReportGenerationHandler";
import {
  buildCurrentCustomerDashboardPath, buildCurrentCustomerDashboardVirtualPath,
  buildCurrentCustomerDocumentsPath, buildCurrentCustomerOtherAssetsListPath,
  buildCurrentCustomerOtherAssetsPath,
  ROUTES
} from "../../routes";
import {customerLogout} from "../../containers/Authentication/Auth/utils";
import InfoTourButton from "../Buttons/InfoTourButton";
import SideMenu from "./components/SideMenu";
import {PrimaryButton} from "../Buttons";


const mapStateToProps = (state) => ({
  auth: state.get('auth').toJS(),
  analyseDropdown: state.get('analyseDropdown').toJS()
});

export default connect(mapStateToProps)(withRouter((props) => {
  const {
    auth,
    location: {pathname},
    showMenuItems
  } = props;

  const classes = useStyles();

  const isActive = (routes) => {
    const isSome = routes.some(route => pathname.includes(route));
    return isSome ? classes.activeLink : '';
  };

  return (
    <AppBar className={classes.header}>
      <div className={classes.pageNav}>
        <ul className={classes.nav}>
          {(
            <React.Fragment>
              {UserUtils.isCustomer(auth) && showMenuItems && (
                <React.Fragment>
                  <li
                    id="portfolio-dashboard-tour-element"
                    className={clsx(
                      classes.item, classes.hideOnSmall, classes.headerItem,
                      classes.customerHeaderFirstItem, isActive([buildCurrentCustomerDashboardPath()])
                    )}
                  >
                    <Link
                      to={buildCurrentCustomerDashboardPath()}
                      className={classes.navLink}
                    >
                      {ROUTES.CUSTOMER.DASHBOARD.name}
                    </Link>
                  </li>
                  {UserUtils.hasVirtualPortfolioAccess(auth) && <li
                    id="virtual-portfolio-dashboard-tour-element"
                    className={clsx(
                      classes.item, classes.hideOnSmall, classes.headerItem,
                      isActive([buildCurrentCustomerDashboardVirtualPath(auth.user.customer_id)])
                    )}
                  >
                    <Link
                      to={buildCurrentCustomerDashboardVirtualPath(auth.user.customer_id)}
                      className={classes.navLink}
                    >
                      {ROUTES.CUSTOMER.DASHBOARD_VIRTUAL.name}
                    </Link>
                  </li>}
                  <li
                    id="assets-tour-element"
                    className={clsx(
                      classes.item, classes.hideOnSmall,
                      classes.headerItem, isActive([buildCurrentCustomerOtherAssetsPath()])
                    )}
                  >
                    <Link
                      to={buildCurrentCustomerOtherAssetsListPath()}
                      className={classes.navLink}
                    >
                      {ROUTES.CUSTOMER.OTHER_ASSETS_LIST.name}
                    </Link>
                  </li>
                  <li
                    id="documents-tour-element"
                    className={clsx(
                      classes.item, classes.hideOnSmall,
                      classes.headerItem, isActive([buildCurrentCustomerDocumentsPath()])
                    )}
                  >
                    <Link
                      to={buildCurrentCustomerDocumentsPath()}
                      className={classes.navLink}
                    >
                      {ROUTES.CUSTOMER.DOCUMENTS.name}
                    </Link>
                  </li>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </ul>
      </div>
      {showMenuItems && auth.user && (
        <div className={classes.funcNav}>
          <ul className={classes.nav}>
            <li
              className={clsx(classes.item, classes.hideOnExtraSmall, classes.buttonItem)}
            >
              <InfoTourButton/>
            </li>
            {UserUtils.isCustomer(auth) && UserUtils.hasVirtualPortfolioAccess(auth) && UserUtils.hasAgencyWebsite(auth) &&
              <li
                className={clsx(classes.item, classes.hideOnExtraSmall, classes.buttonItem, classes.fundsButton)}
              >
              <PrimaryButton
                text='FONDS KAUFEN'
                onButtonClick={() => {
                  window.open(auth.user.agency.website, '_blank')
                }}
              />
              </li>
            }
            <li style={{flex: 1}} />
            {UserUtils.isBroker(auth) && (
              <li className={classes.item}>
                <ReportGenerationHandler />
              </li>
            )}
            {UserUtils.isCustomer(auth) && (
              <li
                id="logout-button-tour-element"
                className={clsx(
                  classes.item, classes.hideOnSmall, classes.headerItem, classes.customerLogoutHeaderItem
                )}
              >
                <a href={null} className={classes.navLink} onClick={() => customerLogout()}>
                  ABMELDEN
                </a>
              </li>
            )}
            <li>
              <SideMenu />
            </li>
          </ul>
        </div>
      )}
    </AppBar>
  )
}))